import React, { useState } from "react";
import api from "../services/api";
import logo from "../assets/MaAz_Logo.png";

function Login({ setLoggedIn }) {

const [email,setEmail] = useState("");
const [password,setPassword] = useState("");
const [loading,setLoading] = useState(false);

const login = async () => {

if(!email || !password){
alert("Please enter email and password");
return;
}

try{

setLoading(true);

/* CLEAR OLD SESSION BEFORE LOGIN */
localStorage.removeItem("token");
localStorage.removeItem("name");
localStorage.removeItem("role");

const res = await api.post("/auth/login",{
email,
password
});

/* SAVE SESSION */

localStorage.clear();

localStorage.setItem("token", res.data.data.token);
localStorage.setItem("name", res.data.data.user.first_name);
localStorage.setItem("role", res.data.data.user.role);

/* LOGIN SUCCESS */

setLoggedIn(true);

}catch(err){

console.log("LOGIN ERROR:", err);

if(err.response && err.response.data){
alert(err.response.data.message || "Login failed");
}else{
alert("Server not reachable");
}

}finally{
setLoading(false);
}

};


/* ENTER KEY LOGIN */

const handleKeyPress = (e) => {
if(e.key === "Enter"){
login();
}
};

return(

<div style={container}>

<div style={card}>

<img
src={logo}
alt="MaAz"
style={logoStyle}
/>

<h2 style={{marginBottom:"25px"}}>
MaAz Admin Login
</h2>

<input
placeholder="Email"
value={email}
onChange={(e)=>setEmail(e.target.value)}
onKeyDown={handleKeyPress}
style={input}
/>

<input
type="password"
placeholder="Password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
onKeyDown={handleKeyPress}
style={input}
/>

<button
onClick={login}
style={button}
disabled={loading}
>
{loading ? "Logging in..." : "Login"}
</button>

</div>

</div>

);

}


/* ---------- UI STYLES ---------- */

const container = {

height:"100vh",
display:"flex",
justifyContent:"center",
alignItems:"center",
background:"#f4f6f8"

};

const card = {

width:"360px",
background:"#fff",
padding:"40px",
borderRadius:"10px",
boxShadow:"0 5px 20px rgba(0,0,0,0.1)",
textAlign:"center"

};

const logoStyle = {

width:"350px",
marginBottom:"20px"

};

const input = {

width:"100%",
padding:"10px",
marginBottom:"15px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"

};

const button = {

width:"100%",
padding:"10px",
background:"#2c3e50",
color:"#fff",
border:"none",
borderRadius:"6px",
cursor:"pointer",
fontSize:"15px"

};

export default Login;
